import { render, staticRenderFns } from "./panel-header.vue?vue&type=template&id=a315887e&"
import script from "./panel-header.vue?vue&type=script&lang=js&"
export * from "./panel-header.vue?vue&type=script&lang=js&"
import style0 from "./panel-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports